import axios from "axios";
import { localGetItem } from "../Components/CommonFunctions/CommonFuntions";

let BASE_DOMAIN = ""
const is_koyili = window.location.pathname.includes("/Koyili");
if (is_koyili) {
  BASE_DOMAIN = "https://koyili.api.emedhub.in/" //KOYILI API URL
} else {
  BASE_DOMAIN = "https://devv4api.emedhub.in/" //DEV API URL
  //  BASE_DOMAIN = "https://qav4api.emedhub.in/" //QA API URL
  //  BASE_DOMAIN = "https://uat.v4.api.emedhub.in/"; //UAT API URL
  //  BASE_DOMAIN = "https://api.emedhub.in/"; //Production API URL
}

const pathToToken = {
  '/Registration/UMA_Pharmacy': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGluaWNfaWQiOiIyMDQiLCJvcmdfaWQiOiI2OTAifQ.LY_qstGgV6Vzs2eWOSNXLCVlFDfrcC81QEUGcAPz4780SSoMPW71h9lpIf1f3AjMr-TtQTtXCMbNz6WzEeACDuFX0JuTpVuQyN1Ddc0HUC2enytTAiBVkYuZmov3oveHM6UqKXzNrVKyATkP8aujBD0l0s_R-RiC2ZvgpauLQkSVyPQOHeHdBnn74qcw3Tj4u42cBzSte4yHyALWNfU3477lnTZcKOJUzStAsE7jCNuBBzAKO8aSXj4zUOECe_kSapctABUn-MGMxS0yecrqYXt5a_RSGBcDS5TtEs6hrpsclvvBjeIgfj8Mz31h1Hbpfp2gBmBcD96JUHODh_zwnQ',
  // QA
  // '/Registration/Shivani_medical_center': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGluaWNfaWQiOiIyMjIiLCJvcmdfaWQiOiI3MDQifQ.miZG7TuCP_WMt1_pLLZ2UueG7K_MJ36lWKgoKOZ2fm5ZGuTPx-tugnXeBHUYNaCWnUlsxzEOBP79gGE2CnC4_SfKxvFGXMMvmGo6htaTLwmy1mFB5Q2EAaGZGrmMEQQvv5nHf4kk5ulib8TqBnLweZOSgGAjFZH831RXRZSRjaGj0_RTQ24ZD2UuttElurEw4XG-nd0_bTUxWu4Yqb-8EPZMdjSBaLtSI8XxBQD7EqN1yf5_UuJdTiFI-WN2G-_wrfNh0229e12MLelmRSLspGZKQ6GgJjMHEoee22tI0hNdCv9EWnVvaHbsV4o-NmNLqrSkrJ1CzMUYsVdR_HDdpw'
  // Live
  '/Registration/Shivani_medical_center': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGluaWNfaWQiOiIxIiwib3JnX2lkIjoiNzA2In0.DR7J7A12xIPXWKWsJ-FqD2hYGvzxDZir_q33yq9b4lWcM0ML7_7b614Duh9G4kacvGlgjYp_iCy9RdQPX3unVa0vJu0ENtXRXDpffdJ_0AptTYh1p2M7F6x9Uo9m2T3vh6wHtb9bQUjLxlQNqzYQO6c5i3emmoy4cko41gSA4HTH3wEmri4H8NUxL_cXQswtF_EVjm3hM2HroIha3h_HyfQlv6pOmfmjxXzuqmQ8VII6Ul-FbE4GhiASHpA8FCi2ANthWdO0k45WR6w9HmjuDAS116eYzVQbcA7h0tk3XeYnM9GcRj8B2Si-lRctTaYHbc9OD_kO3kxSMnNgmUpsxA'
};
const Token = pathToToken[window.location.pathname] || null;
const get = (url) => {
  if (!window.navigator.onLine) {
    return Promise.reject(new Error('No internet connection available'));
  } else {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + (Token ? Token : localGetItem("AccessToken"))
      }
    }).get("/" + url);
  }
}
const post = (url, data) => {
  if (!window.navigator.onLine) {
    return Promise.reject(new Error('No internet connection available'));
  } else {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
      }
    }).post("/" + url, data);
  }
}

const formGet = (url, token) => {
  if (!window.navigator.onLine) {
    return Promise.reject(new Error('No internet connection available'));
  } else {
    return axios.create({
      baseURL: BASE_DOMAIN,
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + (token ? token : localGetItem("AccessToken"))
      }
    }).get("/" + url);
  }
}

export { get, post, formGet };